import { PageWrapper } from '@/components/layouts/PageWrapper';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/Card';

export default function NotFoundPage() {
  return (
    <PageWrapper>
      <Card className="max-w-2xl mx-auto">
        <CardHeader>
          <CardTitle>Page Not Found</CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-gray-600">[Page Name] content will be implemented here.</p>
        </CardContent>
      </Card>
    </PageWrapper>
  );
}